import { palette } from 'app_previous/styles/colors';
import { layout } from 'app_previous/styles/layout';
import styled from 'styled-components';

export const ModalContainer = styled.div`
  padding: 3.125rem 3.75rem;
  box-sizing: border-box;
  border-radius: 16px;
  width: 100%;
  background-color: ${palette.white};
  row-gap: 1rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  .button-primary-large-container {
    width: 100%;

    .button-primary {
      width: 100%;

      @media (max-width: ${layout.sm}) {
        padding: 1rem 1.25rem;
      }
    }
  }

  .hubspot-form-profit-sales-branded-styled-container {
    width: 100%;
  }

  @media (max-width: ${layout.sm}) {
    padding: 3rem;
  }
`;
